import React, { useState } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Typography,
	Box,
	IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import { apiBase } from '../../services/apiBase'
import { api } from '../../utils/api'
import { enqueueSnackbar } from 'notistack'

function ImportFreshStockModal({ open, onClose, type, productId, storeId }) {
	const [importQuantity, setImportQuantity] = useState('')
	const [importPhotos, setImportPhotos] = useState([])

	const handleSubmit = async (event) => {
		event.preventDefault()

		// Validate required fields first
		if (!productId || !storeId || !importQuantity) {
			alert('Vui lòng điền đầy đủ thông tin bắt buộc')
			return
		}

		// Validate importQuantity > 0
		if (parseInt(importQuantity) <= 0) {
			alert('Số lượng phải lớn hơn 0')
			return
		}

		try {
			// Convert photos to base64
			const photoPromises = importPhotos.map((photo) => {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.onload = () => resolve(reader.result)
					reader.onerror = reject
					reader.readAsDataURL(photo)
				})
			})

			const base64Photos = await Promise.all(photoPromises)

			// Send request
			const requestData = {
				value: parseInt(importQuantity),
				productId: productId,
				storeId: storeId,
				images: base64Photos,
			}
			await apiBase.post(api.POST_IMPORT_STOCK, requestData)

			enqueueSnackbar('Nhập kho thành công')
			// Reset form
			setImportQuantity('')
			setImportPhotos([])
			onClose()
		} catch (error) {
			console.error('Error:', error)
			alert(error?.response?.data?.message || 'Có lỗi xảy ra')
		}
	}

	return (
		<Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
			<DialogTitle
				sx={{
					pb: 1,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Typography variant='h6'>Nhập kho {type}</Typography>
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent sx={{ pt: 2 }}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						mb: 3,
					}}>
					<TextField
						fullWidth
						placeholder='Số lượng thực tế (phần)'
						value={importQuantity}
						onChange={(e) => setImportQuantity(e.target.value)}
						sx={{
							'& .MuiOutlinedInput-root': {
								borderRadius: 3,
							},
						}}
					/>
					<label htmlFor='import-photos'>
						<Box
							sx={{
								width: 40,
								height: 40,
								border: '2px dashed #4caf50',
								borderRadius: 2,
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								cursor: 'pointer',
								flexShrink: 0,
							}}>
							<AddPhotoAlternateIcon sx={{ color: '#4caf50', fontSize: 24 }} />
						</Box>
					</label>
					<input
						id='import-photos'
						type='file'
						accept='image/*'
						multiple
						hidden
						onChange={(e) => {
							if (e.target.files) {
								setImportPhotos((prev) => [...prev, ...Array.from(e.target.files)])
							}
						}}
					/>
				</Box>

				{importPhotos.length > 0 && (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 2,
							flexWrap: 'wrap',
						}}>
						{importPhotos.map((photo, index) => (
							<Box
								key={index}
								sx={{
									position: 'relative',
									width: 100,
									height: 100,
								}}>
								<img
									src={URL.createObjectURL(photo)}
									alt={`Import ${index + 1}`}
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										borderRadius: 8,
									}}
								/>
								<IconButton
									size='small'
									sx={{
										position: 'absolute',
										top: -8,
										right: -8,
										backgroundColor: '#fff',
										border: '1px solid #ddd',
										'&:hover': { backgroundColor: '#fff' },
									}}
									onClick={() => {
										setImportPhotos((photos) => photos.filter((_, i) => i !== index))
									}}>
									<CloseIcon fontSize='small' color='error' />
								</IconButton>
							</Box>
						))}
					</Box>
				)}
			</DialogContent>

			<DialogActions sx={{ p: 2, gap: 2 }}>
				<Button
					variant='contained'
					fullWidth
					sx={{
						borderRadius: 8,
						py: 1,
						backgroundColor: '#4caf50',
						'&:hover': { backgroundColor: '#388e3c' },
					}}
					onClick={handleSubmit}>
					Xác nhận
				</Button>
				<Button
					variant='contained'
					fullWidth
					sx={{
						borderRadius: 8,
						py: 1,
						backgroundColor: '#ff5252',
						'&:hover': { backgroundColor: '#d32f2f' },
					}}
					onClick={onClose}>
					Hủy
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ImportFreshStockModal
